export default __webpack_public_path__ + "static/media/Work only with the best.473f4763.png";